import Main from "../components/individual-handling-confirmation-result-update/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/**
 * 個別取扱確認更新
 */
const IndividualHandlingConfirmationResultUpdate = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);

  return <Main />;
};

export default IndividualHandlingConfirmationResultUpdate;
